import React from "react";
import { CategoryForm } from "./CategoryForm";

const SAPCategory =()=>{
    return(
        <>
        <CategoryForm/>
        </>
    )
};

export default SAPCategory;